import { instance } from "./axios";
// const vueAppAdvUrl =
//   window.configs && window.configs.VUE_APP_ADV_URL !== ""
//     ? window.configs.VUE_APP_ADV_URL
//     : process.env.VUE_APP_ADV_URL;
const conditionService = {
  getCondition(email, pkAgency) {
    return instance
      .get(
        `/api/remote-controlled/activation?email=${encodeURIComponent(
          email
        )}&pkAgency=${pkAgency}`
      )
      .then(response => response.data)
      .catch(e => {
        return { success: false, message: e };
      });
  }
};

export default conditionService;
